import { spawn } from 'redux-saga/effects';

import { sagas as statsSagas } from './statsModule';

export default function* bandwidthSagas() {
	yield spawn(statsSagas);
}
